<template>
  <div :id="$route.name">
    <Card back tools toolsColumns>
      <template v-slot:header>
        <h4 class="d-inline">مدیریت قرارداد</h4>
        <hr />
      </template>
      <!-- <template v-slot:btnCustome>
                <a v-if="add" class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="AddRow()" title="ردیف جدید">
                <h4>
                    <i  class="fas fa-plus text-success" style="color:var(--logo-color) !important"></i>
                </h4>
            </a>
            </template> -->
      <template v-slot:content>
        <div class="row" id="ContractRow">
          <div class="col-md-4 col-12">
            <small id="LblTblCostomer">مربوط به مشتری</small>

            <SearchableCombo
              :edit="false"
              :grp="0"
              :code="null"
              :key="combokey"
              @ResultCombo="GetResulTblCostomer"
              :rownumintable="3"
              :defaultvalue="DataAxios.TblCustomerId"
              :action="'TblCrmCombo/GetCostomerProduct'"
              :method="'POST'"
              :idinput="'TblCostomer'"
              :keyItem="'TblCostomer'"
              :disabled="false"
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>

          <div class="col-md-2 col-12">
            <small id="LblTaskDateAz"> از تاریخ </small>
            <date-picker
              color="dimgray"
              v-model="DataAxios.TaskDateAz"
              clearable
              :editable="true"
              placeholder=" از تاریخ"
            ></date-picker>
          </div>
          <div class="col-md-2 col-12">
            <small id="LblTaskDateTa">تا تاریخ</small>
            <date-picker
              color="dimgray"
              v-model="DataAxios.TaskDateTa"
              clearable
              :editable="true"
              placeholder="تا تاریخ "
            ></date-picker>
          </div>
          <div
            class="col-lg-2 col-12"
            v-if="$IsAccess('btnFilterContract!Rasmi')"
          >
            <small id="LblTaskDate">نوع قرارداد</small>
            <SearchableCombo
              :edit="false"
              :grp="12"
              :code="null"
              @ResultCombo="GetResulGrpId39"
              :rownumintable="3"
              :defaultvalue="DataAxios.TblComboGrpId12"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'TblComboGrpId39'"
              :keyItem="'TblComboGrpId39'"
              :disabled="false"
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>
          <div class="col-lg-2 col-12">
            <button
              class="btn btn-success mt-4 float-left w-100 text-center"
              dir="ltr"
              @click.prevent="Search()"
            >
              جستجو <i class="fas fa-search mx-2"></i>
            </button>
          </div>

          <div class="col-lg-3 col-12">
            <button
              v-if="add && $IsAccess('btnSetDeposit')"
              class="btn btn-primary mt-2 float-left w-100 text-center"
              dir="ltr"
              @click.prevent="SetDeposit()"
            >
              ثبت واریز <span class="fad fa-plus mx-2"></span>
            </button>
          </div>
        </div>
        <BnpGrid
          v-if="$store.state.renderComponentGrid"
          :hasRowNum="true"
          :propsColumn="Column"
          :propsRows="Rows"
          :action="true"
        >
          <template slot="action-slot" slot-scope="props">
            <a
              href="javascript:;"
              class="mr-2 badge"
              v-if="
                ($IsAccess('btnEditContract') &&
                  props.props.IsApproval == false) ||
                $session.get('UserInfo').tblGrpId == 1
                || $session.get('UserInfo').tblUserId==205245
              "
              @click="OnEditNew(props.props)"
              ><h5>
                <span
                  class="fas fa-marker text-secondary hover-warning"
                ></span></h5
            ></a>

            <a
              href="javascript:;"
              class="mr-2 badge"
              v-if="
                $IsAccess('btnDetailContract') ||
                $session.get('UserInfo').tblGrpId == 1
                || $session.get('UserInfo').tblUserId==205245
              "
              @click="OnDetailProduct(props.props)"
              data-title="محصولات"
              ><h6><span class="fad fa-info-circle hover-info"></span></h6
            ></a>

            <a
              href="javascript:;"
              class="mr-2 badge"
              v-if="
                ($IsAccess('btnDeleteContract') &&
                  props.props.IsApproval == false) ||
                $session.get('UserInfo').tblGrpId == 1
                || $session.get('UserInfo').tblUserId==205245
              "
              @click="OnDeleteProduct(props.props)"
              data-title="حذف"
              ><h5><span class="fad fa-trash hover-danger"></span></h5
            ></a>

            <!-- <a href="javascript:;" class="mr-2 badge" v-if="($IsAccess('btnDeleteContract') && props.props.TblComboGrpId39 == 1787)" @click="OnSubmitContract(props.props)" data-title="مشاهده قرارداد پیوستی">
              <h5><span class="fad fa-search hover-info"></span></h5>
            </a> -->
          </template>
          <template slot="TotallAmount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.TotallAmount) }}</span>
          </template>
          <template slot="Amount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Amount) }}</span>
          </template>
          <template slot="Toll" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Toll) }}</span>
          </template>
          <template slot="Tax" slot-scope="props">
            <span>{{
              $Comma3ragham(Number(props.props.Toll) + Number(props.props.Tax))
            }}</span>
          </template>
          <template slot="Discount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Discount) }}</span>
          </template>
        </BnpGrid>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Card/Card.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
export default {
  data() {
    return {
      combokey: 0,
      add: false,
      DataAxios: {
        TblComboGrpId12: 1226,
      },
      tarix: [],
      Rows: [],
      Column: [],
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: "frmContract",
          ShowView: 0,
        },
        Method: "post",
        Action: "ReadGridColumns",
      },
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: "post",
        Action: this.$route.name + "/Index",
        Token: this.$session.get("Token"),
      },
      elmAccess: [],
    };
  },
  components: {
    Card,
    datePicker: VuePersianDatetimePicker,
    SearchableCombo,
    BnpGrid,
  },
  methods: {
    AddRow() {
      var row = {};
      row.TblCustomerId = this.DataAxios.TblCustomerId;
      this.$router.push({
        name: "DetailContract",
        params: { Status: "Add", DataRow: row },
      });
    },
    OnEditNew(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row);
      this.$store.state.ContractSerachToEdit = true;

      this.$router.push({
        name: "DetailContract",
        params: { Status: "Edit", TblContract: row },
      });
    },
    GetResulTblCostomer(data) {
      this.DataAxios.TblCustomerId = data.id;
    },
    Search() {
      var valid = false;
      if (
        this.$store.state.ContractSearch.length > 0 &&
        this.$store.state.ContractModel &&
        this.$store.state.ContractModel.TblCustomerId != null
      ) {
        valid = true;
      } else {
        valid = this.$ValidForm(this.$route.name);
      }

      if (valid) {
        var row = {};
        this.Rows = [];

        this.DataAxios_GetData.ArryfildValue = this.DataAxios;
        this.$store.state.ContractModel = this.DataAxios;
        this.$PostData(this.DataAxios_GetData)
          .then((data) => {
            if (data.length > 0 && data[0].Id != null) {
              this.add = true;
              for (let index = 0; index < data.length; index++) {
                this.Rows.push(data[index]);
              }
              this.$store.state.ContractSearch = this.Rows;
            } else {
              // console.log('No Data')
              this.Rows = [];
              this.add = false;
            }
            this.$store.state.ContractSearch = data;
          })
          .finally(() => {
            this.loadingRender = false;
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      }
    },
    OnDetailProduct(row) {
      this.$router.push({
        name: "DetailContract",
        params: {
          Status: "Product",
          TblContract: row,
          IsAccessDelete:
            this.$IsAccess("btnDeleteContract") && row.IsApproval == false,
          IsAccessSetDeposit: this.$IsAccess("btnSetDeposit"),
        },
      });
    },
    OnDeleteProduct(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row);
      let DataAxios_DeleteData = {
        ArryfildValue: row,
        Method: "delete",
        Action: "Contract",
        Token: this.$session.get("Token"),
      };

      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mx-1",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "اطمینان دارید؟",
          text: "از حذف قرارداد " + " ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "بله، حذف شود",
          cancelButtonText: "لغو",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$PostData(DataAxios_DeleteData)
              .then((data) => {
                if (data.status == "Ok") {
                  this.$toasted.success("حذف قرارداد با موفقیت انجام گردید", {
                    duration: 3000,
                  });

                  this.$SetLog(DataAxios_DeleteData.ArryfildValue, 1);
                  this.Search();
                } else if (data.status == "Not Ok") {
                  this.$toasted.error(data.msg, { duration: 10000 });
                } else {
                  if (data.eNum == 547) {
                    this.$toasted.error(
                      "امکان حذف قرارداد وجود ندارد ، قرارداد شما داری محصول می باشد. ابتدا محصولات قرارداد رو حذف نمایید",
                      { duration: 8000 }
                    );
                    // this.$mySweetDefaultTost('عملیات ناموفق', 'امکان حذف قرارداد وجود ندارد ، قرارداد شما داری محصول می باشد. ابتدا محصولات قرارداد رو حذف نمایید', 'warning', 5000)
                  }
                }
              })
              .finally(() => {
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true;
                });
              });
          }
        });
    },
    GetResulGrpId39(data) {
      this.DataAxios.TblComboGrpId12 = data.id;
    },
    /* GetAccessUser() {
      var menu = this.$session.get('Menu')
      var IdMenu = menu.find((x) => x.RouteName == this.$route.name).id
      this.elmAccess = menu.filter((x) => x.ParentId == IdMenu)
      },
      IsAccess(elmId) {
        let IsExist = false
        this.elmAccess.forEach((element) => {
          if (element.ControlName == elmId) {
            if (element.isMojaz == 1) {
              IsExist = true
            }
          }
        })
        return IsExist
    },*/
    SetDeposit() {
      this.$router.push({
        name: "Deposit",
        params: { Status: "Add", TblCustomerId: this.DataAxios.TblCustomerId },
      });
    },
    /*  OnSubmitContract(row){
       let DataAxios_Data = {
        ArryfildValue: row,
        Method: 'post',
        Action: 'Contract/FindSubmitContract',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_Data)
        .then((data) => {
          if (data.status == 'Ok') {
                this.$router.push({
                  name: 'DetailContract',
                  params: {
                    Status: 'Product',
                    TblContract: data.Contract,
                    IsAccessDelete: this.$IsAccess('btnDeleteContract') && row.IsApproval == false,
                    IsAccessSetDeposit: this.$IsAccess('btnSetDeposit'),
                  },
                })
          } else {
            if (data.eNum == 547) {
              this.$mySweetDefaultTost('عملیات ناموفق', 'امکان ثبت قرارداد وجود ندارد ، قرارداد شما داری محصول می باشد. ابتدا محصولات قرارداد رو حذف نمایید', 'warning', 5000)
            }
            console.log(data)
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    }*/
  },
  mounted() {
    this.$GetAccessUser();
    // this.GetAccessUser()
    console.log(this.TblCustomerId);
    if (this.TblCustomerId) {
      this.DataAxios.TblCustomerId = this.TblCustomerId;
      // this.Search()
    }

    this.$GetColumns(this.DataAxoisCol, true)
      .then((data) => {
        this.Column = data;
        this.Column.push({
          id: 2416,
          name: "IsApproval",
          visibility: true,
          label: "تایید مدیر",
        });
        this.Column.push({
          id: 2500,
          name: "Id",
          visibility: true,
          label: "شماره قرارداد",
        });
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true;
          if (
            this.$store.state.ContractSearch.length > 0 &&
            this.$store.state.ContractModel &&
            this.$store.state.ContractModel.TblCustomerId != null
          ) {
            // console.log(this.$store.state.ContractModel)
            this.DataAxios = this.$store.state.ContractModel;
            // console.warn(document.getElementById('TblCostomer').value)

            this.Search();
            // this.Rows = this.$store.state.ContractSearch
          }
        });
      });
  },
  created() {},

  props: ["TblCustomerId", "Data"],
};
</script>
<style scoped></style>
